import React, { Component } from "react";
import {
    faPlus,
    faSearch,
    faFileExport,
    faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import moment from "moment";
import "./loader.css";
import { Auth } from "aws-amplify";
import Multiselect from "react-widgets/Multiselect";
import "react-widgets/styles.css";
import { motivosdes, motivoshab } from "../motivos";
import "./reporte.css"

let motivosall = motivosdes.concat(motivoshab)

class Reporte extends Component {
    constructor(props) {
        super(props);
        this.state = {
            FechaInicio: new Date(),
            FechaFin: new Date(),
            Sku: [],
            ObtenerHistorial: false,
            ObtenerEstadoActual: "",
            Usuario: "",
            EsRangoFecha: "",
            Accion: "HAB",
            Motivo: [],
            HasFechas: false,
            HasSku: false,
            HasObtenerHistorial: false,
            HasObtenerEstadoActual: false,
            HasUsuario: false,
            HasEsRangoFecha: false,
            HasAccion: false,
            HasMotivo: false,

            HistorialActual: [],
            StatusActual: [],

            nextTokenStatus: "",
            nextTokenHistorial: "",

            listadoStatus: {},
            listadoHistorial: {},

            dataCargada: false,
            viendoStatus: true,
            actual_sku_filter: "",
            notification: "",
            hasNotification: false,
            search_button_disabled: false,
            download_button_disabled: false,
            paginaActualStatus: 0,
            paginaActualHistorial: 0,
            somethingChanged: false,
            obtuvoHistorial: false,
            itemPerPage: 50,
            collapseClass: "collapse show",
            showLoader: false,
            mail: "",
        };
        this.RunStatus = this.RunStatus.bind(this);
        this.renderSkus = this.renderSkus.bind(this);
        this.RenderStatus = this.RenderStatus.bind(this);
        this.RenderHistorial = this.RenderHistorial.bind(this);
        this.RunStatusBefore = this.RunStatusBefore.bind(this);
        this.DescargarReporte = this.DescargarReporte.bind(this);
        this.RunHistorialBefore = this.RunHistorialBefore.bind(this);
        this.removerfiltroMotivo = this.removerfiltroMotivo.bind(this)
    }

    removerfiltroMotivo = (hasAccion, accion) =>{
        let newMotivos = []
        if(hasAccion){
            if(accion === "DES"){
                this.state.Motivo.forEach(function(e, i){
                    if(motivosdes.includes(e)){
                        newMotivos.push(e)
                    }
                });
            }else if(accion === "HAB"){
                this.state.Motivo.forEach(function(e, i){
                    if(motivoshab.includes(e)){
                        newMotivos.push(e)
                    }
                });
            }
        }else{
            newMotivos = this.state.Motivo
        }
        this.setState({Motivo: newMotivos})
        console.log(this.state.Motivo)
    }

    async componentDidMount() {
        try {
            let user = await Auth.currentAuthenticatedUser();
            const { attributes } = user;
            this.setState({
                mail: attributes.email,
            });
        } catch (e) {
            this.setState({
                hasError: true,
                notification: (
                    <div className="alert alert-danger">
                        Hubo un error obteniendo su informacion
                    </div>
                ),
            });
        }
    }

    async RunStatusBefore() {
        let pagina_actual = this.state.paginaActualStatus;
        if (this.state.listadoStatus.hasOwnProperty(pagina_actual - 1)) {
            if (!this.state.listadoStatus.hasOwnProperty(pagina_actual)) {
                let listado = this.state.listadoStatus;
                listado[pagina_actual] = this.state.StatusActual;
                await this.setState({
                    listadoStatus: listado,
                });
            }
            await this.setState({
                StatusActual: this.state.listadoStatus[pagina_actual - 1],
                paginaActualStatus: pagina_actual - 1,
            });
        }
    }

    async RunHistorialBefore() {
        let pagina_actual = this.state.paginaActualHistorial;
        if (this.state.listadoHistorial.hasOwnProperty(pagina_actual - 1)) {
            if (!this.state.listadoHistorial.hasOwnProperty(pagina_actual)) {
                let listado = this.state.listadoHistorial;
                listado[pagina_actual] = this.state.HistorialActual;
                await this.setState({
                    listadoHistorial: listado,
                });
            }
            await this.setState({
                HistorialActual: this.state.listadoHistorial[pagina_actual - 1],
                paginaActualHistorial: pagina_actual - 1,
            });
        }
    }

    DescargarReporte() {
        this.setState({
            download_button_disabled: true,
            hasNotification: false,
            somethingChanged: false,
            showLoader: true,
        });
        let query_params = {};
        if (this.state.HasSku) query_params.Sku = this.state.Sku.join();
        if (this.state.HasAccion) query_params.Accion = this.state.Accion;
        if (this.state.HasMotivo)
            query_params.Motivo = this.state.Motivo.join(",");
        if (this.state.HasUsuario) query_params.Usuario = this.state.Usuario;
        if (this.state.HasFechas) {
            query_params.FechaInicio = moment(this.state.FechaInicio).format(
                "YYYY-MM-DD"
            );
            query_params.FechaFin = moment(this.state.FechaFin).format(
                "YYYY-MM-DD"
            );
        }
        query_params.Correo = this.state.mail;
        if (this.state.ObtenerHistorial)
            query_params.ObtenerHistorial = this.state.ObtenerHistorial;
        axios({
            url: process.env.REACT_APP_API_URL + "/api/v1/reporte/generar",
            params: query_params,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then((data) => {
                this.setState({
                    hasNotification: true,
                    notification: (
                        <div className="alert alert-success" role="alert">
                            {data.data.message}
                        </div>
                    ),
                });
            })
            .catch((error) => {
                this.setState({
                    hasNotification: true,
                    notification: (
                        <div className="alert alert-danger" role="alert">
                            Hubo un error
                        </div>
                    ),
                });
            })
            .finally(() => {
                this.setState({
                    download_button_disabled: false,
                    showLoader: false,
                });
            });
    }

    async RunStatus() {
        let pagina_actual = this.state.paginaActualStatus;
        if (this.state.listadoStatus.hasOwnProperty(pagina_actual + 1)) {
            await this.setState({
                StatusActual: this.state.listadoStatus[pagina_actual + 1],
                paginaActualStatus: pagina_actual + 1,
            });
        } else {
            if (!this.state.search_button_disabled) {
                this.setState({
                    search_button_disabled: true,
                    hasNotification: false,
                    dataCargada: false,
                    somethingChanged: false,
                    showLoader: true,
                });
                let query_params = {
                    CantidadItems: this.state.itemPerPage,
                };
                if (this.state.HasSku) query_params.Sku = this.state.Sku.join();
                if (this.state.HasAccion)
                    query_params.Accion = this.state.Accion;
                if (this.state.HasMotivo)
                    query_params.Motivo = this.state.Motivo.toString();
                if (this.state.HasUsuario)
                    query_params.Usuario = this.state.Usuario;
                if (this.state.HasFechas) {
                    query_params.FechaInicio = moment(
                        this.state.FechaInicio
                    ).format("YYYY-MM-DD");
                    query_params.FechaFin = moment(this.state.FechaFin).format(
                        "YYYY-MM-DD"
                    );
                }
                if (this.state.nextTokenStatus !== "")
                    query_params.start_token = this.state.nextTokenStatus;
                axios({
                    url:
                        process.env.REACT_APP_API_URL +
                        "/api/v1/reporte/status",
                    params: query_params,
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                    .then(async (data) => {
                        await this.setState({
                            dataCargada: true,
                            StatusActual: data.data.Status,
                            nextTokenStatus: data.data.is_last
                                ? ""
                                : data.data.start_token,
                            paginaActualStatus: pagina_actual + 1,
                        });
                        let listado = this.state.listadoStatus;
                        listado[pagina_actual + 1] = this.state.StatusActual;
                        this.setState({
                            listadoStatus: listado,
                        });
                    })
                    .catch((error) => {
                        this.setState({
                            hasNotification: true,
                            notification: (
                                <div
                                    className="alert alert-danger"
                                    role="alert"
                                >
                                    Hubo un error
                                </div>
                            ),
                        });
                    })
                    .finally(() => {
                        this.setState({
                            search_button_disabled: false,
                        });
                    });
            }
        }
    }

    async RunHistorial() {
        let pagina_actual = this.state.paginaActualStatus;
        if (this.state.listadoHistorial.hasOwnProperty(pagina_actual + 1)) {
            await this.setState({
                HistorialActual: this.state.listadoHistorial[pagina_actual + 1],
                paginaActualHistorial: pagina_actual + 1,
            });
        } else {
            if (!this.state.search_button_disabled) {
                this.setState({
                    search_button_disabled: true,
                    hasNotification: false,
                    dataCargada: false,
                    somethingChanged: false,
                    showLoader: true,
                });
                let query_params = {
                    CantidadItems: this.state.itemPerPage,
                };
                if (this.state.HasSku) query_params.Sku = this.state.Sku.join();
                if (this.state.HasAccion)
                    query_params.Accion = this.state.Accion;
                if (this.state.HasMotivo)
                    query_params.Motivo = this.state.Motivo.toString();
                if (this.state.HasUsuario)
                    query_params.Usuario = this.state.Usuario;
                if (this.state.HasFechas) {
                    query_params.FechaInicio = moment(
                        this.state.FechaInicio
                    ).format("YYYY-MM-DD");
                    query_params.FechaFin = moment(this.state.FechaFin).format(
                        "YYYY-MM-DD"
                    );
                }
                if (this.state.nextTokenHistorial !== "")
                    query_params.start_token = this.state.nextTokenHistorial;
                axios({
                    url:
                        process.env.REACT_APP_API_URL +
                        "/api/v1/reporte/historial",
                    params: query_params,
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                    .then(async (data) => {
                        await this.setState({
                            dataCargada: true,
                            HistorialActual: data.data.Historial,
                            nextTokenHistorial: data.data.is_last
                                ? ""
                                : data.data.start_key,
                            paginaActualHistorial: pagina_actual + 1,
                        });
                        let listado = this.state.listadoHistorial;
                        listado[pagina_actual] = this.state.HistorialActual;
                        await this.setState({
                            listadoHistorial: listado,
                        });
                    })
                    .catch((error) => {
                        this.setState({
                            hasNotification: true,
                            notification: (
                                <div
                                    className="alert alert-danger"
                                    role="alert"
                                >
                                    Hubo un error
                                </div>
                            ),
                        });
                    })
                    .finally(() => {
                        this.setState({
                            search_button_disabled: false,
                        });
                    });
            }
        }
    }

    renderSkus() {
        return this.state.Sku.map((item, index) => {
            return (
                <span className="badge badge-primary mr-2" key={index}>
                    {item}&nbsp;&nbsp;
                    <span
                        aria-hidden="true"
                        style={{
                            fontSize: "1.25em",
                            cursor: "pointer",
                        }}
                        onClick={() => {
                            let sku_list = this.state.Sku;
                            sku_list.splice(index, 1);
                            this.setState({
                                Sku: sku_list,
                            });
                        }}
                    >
                        &times;
                    </span>
                </span>
            );
        });
    }

    RenderStatus() {
        if (this.state.dataCargada) {
            if (this.state.StatusActual.length > 0) {
                return this.state.StatusActual.map((item, index) => {
                    return (
                        <tr key={index}>
                            <td>{item.Sku}</td>
                            <td>{item.Solicitado_por}</td>
                            <td>{item.Motivo}</td>
                            <td>{item.Comentario}</td>
                            <td>
                                {item.Accion === "DES"
                                    ? "Desactivado"
                                    : "Activado"}
                            </td>
                            <td>
                                {moment
                                    .unix(item.Fecha)
                                    .format("DD/MM/YYYY hh:mm a")}
                            </td>
                            <td>{item.Usuario}</td>
                        </tr>
                    );
                });
            } else {
                return (
                    <tr>
                        <td colSpan="5">
                            <p className="text-center">
                                No se encontraron resultados
                            </p>
                        </td>
                    </tr>
                );
            }
        }
    }

    RenderHistorial() {
        if (this.state.dataCargada) {
            if (this.state.HistorialActual.length > 0) {
                return this.state.HistorialActual.map((item, index) => {
                    return (
                        <tr key={index}>
                            <td>{item.Sku}</td>
                            <td>{item.Solicitado_por}</td>
                            <td>{item.Motivo}</td>
                            <td>{item.Comentario}</td>
                            <td>
                                {item.Accion === "DES"
                                    ? "Desactivado"
                                    : "Activado"}
                            </td>
                            <td>
                                {moment
                                    .unix(item.Fecha)
                                    .format("DD/MM/YYYY hh:mm a")}
                            </td>
                            <td>{item.Usuario}</td>
                        </tr>
                    );
                });
            } else {
                return (
                    <tr>
                        <td colSpan="5">
                            <p className="text-center">
                                No se encontraron resultados
                            </p>
                        </td>
                    </tr>
                );
            }
        }
    }

    RenderPaginacion() {
        if (this.state.viendoStatus) {
            return (
                <div className="row">
                    <div className="col-sm-6">
                        <nav aria-label="Paginacion del status">
                            <ul className="pagination justify-content-start">
                                <li
                                    className={
                                        "page-item " +
                                        (this.state.paginaActualStatus === 1
                                            ? " disabled"
                                            : "")
                                    }
                                >
                                    <button
                                        className="btn btn-link page-link"
                                        onClick={async () =>
                                            await this.RunStatusBefore()
                                        }
                                    >
                                        Anterior
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div className="col-sm-6">
                        <nav aria-label="Paginacion del status">
                            <ul className="pagination justify-content-end">
                                <li
                                    className={
                                        "page-item " +
                                        (this.state.nextTokenStatus === "" &&
                                        Object.keys(this.state.listadoStatus)
                                            .length ===
                                            this.state.paginaActualStatus
                                            ? " disabled"
                                            : "")
                                    }
                                >
                                    <button
                                        className="btn btn-link page-link"
                                        onClick={async () =>
                                            await this.RunStatus()
                                        }
                                    >
                                        Siguiente
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="row">
                    <div className="col-sm-6">
                        <nav aria-label="Paginacion del status">
                            <ul className="pagination justify-content-start">
                                <li
                                    className={
                                        "page-item " +
                                        (this.state.paginaActualHistorial === 1
                                            ? " disabled"
                                            : "")
                                    }
                                >
                                    <button
                                        className="btn btn-link page-link"
                                        onClick={async () =>
                                            await this.RunHistorialBefore()
                                        }
                                    >
                                        Anterior
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div className="col-sm-6">
                        <nav aria-label="Paginacion del status">
                            <ul className="pagination justify-content-end">
                                <li
                                    className={
                                        "page-item " +
                                        (this.state.nextTokenHistorial === "" &&
                                        Object.keys(this.state.listadoHistorial)
                                            .length ===
                                            this.state.paginaActualHistorial
                                            ? " disabled"
                                            : "")
                                    }
                                >
                                    <button
                                        className="btn btn-link page-link"
                                        onClick={async () =>
                                            await this.RunHistorial()
                                        }
                                    >
                                        Siguiente
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            );
        }
    }

    render() {
        let body_table = (
            <div>
                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th>SKU</th>
                            <th>Solicitado Por</th>
                            <th>Motivo</th>
                            <th>Comentario</th>
                            <th>Accion</th>
                            <th>Fecha</th>
                            <th>Usuario</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.viendoStatus
                            ? this.RenderStatus()
                            : this.RenderHistorial()}
                    </tbody>
                </table>
                <div>{this.RenderPaginacion()}</div>
            </div>
        );
        return (
            <div className="mt-5">
                <div className="row">
                    <div className="col-md-12">
                        {this.state.hasNotification
                            ? this.state.notification
                            : null}
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-md-12">
                        <div
                            className="accordion"
                            id="filterAccordion"
                            data-toggle="collapse"
                            data-target="filterContent"
                        >
                            <div className="card shadow-sm p-3 mb-5 bg-white rounded">
                                <div
                                    className="card-title bg-transparent"
                                    id="filterHeader"
                                >
                                    <h2 className="mb-0">
                                        <div className="row">
                                            <div className="col-8 col-sm-10 col-md-10">
                                                <button
                                                    className="btn btn-link btn-block text-left"
                                                    type="button"
                                                    data-toggle="collapse"
                                                    data-target="#filterContent"
                                                    aria-expanded="true"
                                                    aria-controls="filterContent"
                                                >
                                                    Filtros
                                                </button>
                                            </div>
                                            <div className="col-4 col-sm-2 col-md-2 d-flex justify-content-end">
                                                <div className="btn-group dropleft">
                                                    <button
                                                        className="btn btn-sm dropdown-toggle"
                                                        type="button"
                                                        id="filterCardDropdown"
                                                        data-toggle="dropdown"
                                                    >
                                                        <FontAwesomeIcon
                                                            role="button"
                                                            icon={faPlus}
                                                        />
                                                    </button>
                                                    <div
                                                        className="dropdown-menu"
                                                        aria-labelledby="filterCardDropdown"
                                                    >
                                                        <button
                                                            className={
                                                                "btn btn-link btn-sm dropdown-item" +
                                                                (this.state
                                                                    .HasFechas
                                                                    ? " disabled"
                                                                    : "")
                                                            }
                                                            onClick={() => {
                                                                this.setState({
                                                                    HasFechas: true,
                                                                });
                                                            }}
                                                        >
                                                            Rango de fechas
                                                        </button>
                                                        <button
                                                            className={
                                                                "btn btn-link btn-sm dropdown-item" +
                                                                (this.state
                                                                    .HasSku
                                                                    ? " disabled"
                                                                    : "")
                                                            }
                                                            onClick={() => {
                                                                this.setState({
                                                                    HasSku: true,
                                                                });
                                                            }}
                                                        >
                                                            Sku
                                                        </button>
                                                        <button
                                                            className={
                                                                "btn btn-link btn-sm dropdown-item" +
                                                                (this.state
                                                                    .HasUsuario
                                                                    ? " disabled"
                                                                    : "")
                                                            }
                                                            onClick={() => {
                                                                this.setState({
                                                                    HasUsuario: true,
                                                                });
                                                            }}
                                                        >
                                                            Usuario
                                                        </button>
                                                        <button
                                                            className={
                                                                "btn btn-link btn-sm dropdown-item" +
                                                                (this.state
                                                                    .HasAccion
                                                                    ? " disabled"
                                                                    : "")
                                                            }
                                                            onClick={() => {
                                                                this.setState({
                                                                    HasAccion: true,
                                                                });
                                                                this.removerfiltroMotivo(true, this.state.Accion)
                                                            }}
                                                        >
                                                            Accion
                                                        </button>
                                                        <button
                                                            className={
                                                                "btn btn-link btn-sm dropdown-item" +
                                                                (this.state
                                                                    .HasMotivo
                                                                    ? " disabled"
                                                                    : "")
                                                            }
                                                            onClick={() => {
                                                                this.setState({
                                                                    HasMotivo: true,
                                                                });
                                                            }}
                                                        >
                                                            Motivo
                                                        </button>
                                                        <div className="dropdown-divider"></div>
                                                        <div className="form-group px-3">
                                                            <div className="form-check">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    id="get-history-check"
                                                                    checked={
                                                                        this
                                                                            .state
                                                                            .ObtenerHistorial
                                                                    }
                                                                    onChange={(
                                                                        e
                                                                    ) => {
                                                                        this.setState(
                                                                            {
                                                                                ObtenerHistorial:
                                                                                    e
                                                                                        .target
                                                                                        .checked,
                                                                                obtuvoHistorial:
                                                                                    e
                                                                                        .target
                                                                                        .checked,
                                                                            }
                                                                        );
                                                                    }}
                                                                />
                                                                <label
                                                                    className="form-check-label"
                                                                    htmlFor="get-history-check"
                                                                    style={{
                                                                        fontSize:
                                                                            "0.875rem",
                                                                    }}
                                                                >
                                                                    Obtener todo
                                                                    el historial
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </h2>
                                </div>
                                <div
                                    className="collapse show"
                                    id="filterContent"
                                    aria-labelledby="filterHeader"
                                    data-parent="#filterAccordion"
                                >
                                    <div className="card-body">
                                        {this.state.HasFechas ||
                                        this.state.HasAccion ||
                                        this.state.HasMotivo ||
                                        this.state.HasSku ||
                                        this.state.HasUsuario ? (
                                            <div className="row">
                                                <div
                                                    className={
                                                        "py-1 col-12 col-sm-12 col-md-12 col-lg-6 " +
                                                        (!this.state.HasFechas
                                                            ? "d-none"
                                                            : "")
                                                    }
                                                >
                                                    <div className="card bg-ligth shadow p-3 mb-5 bg-white rounded">
                                                        <div className="card-body">
                                                            <div className="card-title mb-4">
                                                                <strong>
                                                                    Seleccione
                                                                    su rango de
                                                                    fechas
                                                                </strong>
                                                                <button
                                                                    className="btn btn-danger btn-sm float-right"
                                                                    onClick={() => {
                                                                        this.setState(
                                                                            {
                                                                                HasFechas: false,
                                                                                somethingChanged: true,
                                                                                nextTokenHistorial:
                                                                                    "",
                                                                                nextTokenStatus:
                                                                                    "",
                                                                            }
                                                                        );
                                                                    }}
                                                                >
                                                                    <FontAwesomeIcon
                                                                        role="button"
                                                                        icon={
                                                                            faTimes
                                                                        }
                                                                    />
                                                                </button>
                                                            </div>
                                                            <hr className="mb-4" />
                                                            <div className="row">
                                                                <div className="col-md-12 text-center">
                                                                    <div className="row">
                                                                        <div className="col-6 col-sm-6 col-md-6 col-lg-12">
                                                                            <div className="row">
                                                                                <div className="col-md-5">
                                                                                    <label htmlFor="finicio">
                                                                                        Fecha
                                                                                        de
                                                                                        inicio{" "}
                                                                                    </label>
                                                                                </div>
                                                                                <div className="col-md-6">
                                                                                    <DatePicker
                                                                                        className="form-control"
                                                                                        id="finicio"
                                                                                        selected={
                                                                                            this
                                                                                                .state
                                                                                                .FechaInicio
                                                                                        }
                                                                                        onChange={(
                                                                                            date
                                                                                        ) => {
                                                                                            this.setState(
                                                                                                {
                                                                                                    FechaInicio:
                                                                                                        date,
                                                                                                    somethingChanged: true,
                                                                                                    nextTokenHistorial:
                                                                                                        "",
                                                                                                    nextTokenStatus:
                                                                                                        "",
                                                                                                }
                                                                                            );
                                                                                        }}
                                                                                        startDate={
                                                                                            this
                                                                                                .state
                                                                                                .FechaInicio
                                                                                        }
                                                                                        endDate={
                                                                                            this
                                                                                                .state
                                                                                                .FechaFin
                                                                                        }
                                                                                        selectsStart
                                                                                        placeholderText="Fecha de inicio"
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-6 col-sm-6 col-md-6 col-lg-12">
                                                                            <div className="row">
                                                                                <div className="col-md-5">
                                                                                    <label htmlFor="ffin">
                                                                                        Fecha
                                                                                        de
                                                                                        fin{" "}
                                                                                    </label>
                                                                                </div>
                                                                                <div className="col-md-6">
                                                                                    <DatePicker
                                                                                        className="form-control"
                                                                                        id="ffin"
                                                                                        selected={
                                                                                            this
                                                                                                .state
                                                                                                .FechaFin
                                                                                        }
                                                                                        startDate={
                                                                                            this
                                                                                                .state
                                                                                                .FechaInicio
                                                                                        }
                                                                                        selectsEnd
                                                                                        endDate={
                                                                                            this
                                                                                                .state
                                                                                                .FechaFin
                                                                                        }
                                                                                        minDate={
                                                                                            this
                                                                                                .state
                                                                                                .FechaInicio
                                                                                        }
                                                                                        onChange={(
                                                                                            date
                                                                                        ) => {
                                                                                            this.setState(
                                                                                                {
                                                                                                    FechaFin:
                                                                                                        date,
                                                                                                    somethingChanged: true,
                                                                                                    nextTokenHistorial:
                                                                                                        "",
                                                                                                    nextTokenStatus:
                                                                                                        "",
                                                                                                }
                                                                                            );
                                                                                        }}
                                                                                        placeholderText="Fecha de fin"
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className={
                                                        "py-1 col-12 col-sm-12 col-md-12 col-lg-6 " +
                                                        (!this.state.HasSku
                                                            ? "d-none"
                                                            : "")
                                                    }
                                                >
                                                    <div className="card bg-ligth shadow p-3 mb-5 bg-white rounded">
                                                        <div className="card-body">
                                                            <div className="card-title mb-4">
                                                                <strong>
                                                                    SKU
                                                                </strong>
                                                                <button
                                                                    className="btn btn-danger btn-sm float-right"
                                                                    onClick={() => {
                                                                        this.setState(
                                                                            {
                                                                                HasSku: false,
                                                                                somethingChanged: true,
                                                                                nextTokenHistorial:
                                                                                    "",
                                                                                nextTokenStatus:
                                                                                    "",
                                                                            }
                                                                        );
                                                                    }}
                                                                >
                                                                    <FontAwesomeIcon
                                                                        role="button"
                                                                        icon={
                                                                            faTimes
                                                                        }
                                                                    />
                                                                </button>
                                                            </div>
                                                            <hr className="mb-4" />
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <div className="input-group mb-3">
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            value={
                                                                                this
                                                                                    .state
                                                                                    .actual_sku_filter
                                                                            }
                                                                            placeholder="Sku"
                                                                            aria-label="Sku"
                                                                            aria-describedby="Sku"
                                                                            id="sku_filter"
                                                                            onChange={(
                                                                                e
                                                                            ) => {
                                                                                this.setState(
                                                                                    {
                                                                                        actual_sku_filter:
                                                                                            e
                                                                                                .target
                                                                                                .value,
                                                                                    }
                                                                                );
                                                                            }}
                                                                        />
                                                                        <div className="input-group-append">
                                                                            <button
                                                                                className="btn btn-outline-primary"
                                                                                type="button"
                                                                                onClick={(
                                                                                    e
                                                                                ) => {
                                                                                    if (
                                                                                        this
                                                                                            .state
                                                                                            .actual_sku_filter
                                                                                            .length >
                                                                                        0
                                                                                    ) {
                                                                                        let skus_input =
                                                                                            this.state.actual_sku_filter.split(
                                                                                                /[.,/ \-\n\t_]/
                                                                                            );
                                                                                        console.log(
                                                                                            skus_input
                                                                                        );
                                                                                        let skus_input_conjunto =
                                                                                            new Set(
                                                                                                skus_input
                                                                                            );
                                                                                        let sku_list =
                                                                                            this
                                                                                                .state
                                                                                                .Sku;
                                                                                        let sku_list_conjunto =
                                                                                            new Set(
                                                                                                sku_list
                                                                                            );
                                                                                        let skus_conjunto =
                                                                                            new Set(
                                                                                                [
                                                                                                    ...skus_input_conjunto,
                                                                                                    ...sku_list_conjunto,
                                                                                                ]
                                                                                            );
                                                                                        this.setState(
                                                                                            {
                                                                                                Sku: Array.from(
                                                                                                    skus_conjunto
                                                                                                ),
                                                                                                actual_sku_filter:
                                                                                                    "",
                                                                                                somethingChanged: true,
                                                                                                nextTokenHistorial:
                                                                                                    "",
                                                                                                nextTokenStatus:
                                                                                                    "",
                                                                                            }
                                                                                        );
                                                                                    }
                                                                                }}
                                                                            >
                                                                                Agregar
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    {this.renderSkus()}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className={
                                                        "py-1 col-12 col-sm-12 col-md-6 col-lg-6 " +
                                                        (!this.state.HasAccion
                                                            ? "d-none"
                                                            : "")
                                                    }
                                                >
                                                    <div className="card bg-ligth shadow p-3 mb-5 bg-white rounded">
                                                        <div className="card-body">
                                                            <div className="card-title mb-4">
                                                                <strong>
                                                                    Accion
                                                                </strong>
                                                                <button
                                                                    className="btn btn-danger btn-sm float-right"
                                                                    onClick={() => {
                                                                        this.setState(
                                                                            {
                                                                                HasAccion: false,
                                                                                somethingChanged: true,
                                                                                nextTokenHistorial:
                                                                                    "",
                                                                                nextTokenStatus:
                                                                                    "",
                                                                            }
                                                                        );
                                                                    }}
                                                                >
                                                                    <FontAwesomeIcon
                                                                        role="button"
                                                                        icon={
                                                                            faTimes
                                                                        }
                                                                    />
                                                                </button>
                                                            </div>
                                                            <hr className="mb-4" />
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <div className="form-group">
                                                                        <select
                                                                            className="form-control"
                                                                            id="seleccion-accion"
                                                                            onChange={(
                                                                                e
                                                                            ) => {
                                                                                this.setState(
                                                                                    {
                                                                                        Accion: e
                                                                                            .target
                                                                                            .value,
                                                                                        somethingChanged: true,
                                                                                        nextTokenHistorial:
                                                                                            "",
                                                                                        nextTokenStatus:
                                                                                            "",
                                                                                    }
                                                                                );
                                                                                this.removerfiltroMotivo(this.state.HasAccion, e.target.value)
                                                                            }}
                                                                        >
                                                                            <option value="HAB">
                                                                                Habilitar
                                                                            </option>
                                                                            <option value="DES">
                                                                                Deshabilitar
                                                                            </option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div
                                                    className={
                                                        "py-1 col-12 col-sm-12 col-md-6 col-lg-6 " +
                                                        (!this.state.HasMotivo
                                                            ? "d-none"
                                                            : "")
                                                    }
                                                >
                                                    <div className="card bg-ligth shadow p-3 mb-5 bg-white rounded">
                                                        <div className="card-body">
                                                            <div className="card-title mb-4">
                                                                <strong>
                                                                    Motivo
                                                                </strong>
                                                                <button
                                                                    className="btn btn-danger btn-sm float-right"
                                                                    onClick={() => {
                                                                        this.setState(
                                                                            {
                                                                                HasMotivo: false,
                                                                                somethingChanged: true,
                                                                                nextTokenHistorial:
                                                                                    "",
                                                                                nextTokenStatus:
                                                                                    "",
                                                                            }
                                                                        );
                                                                    }}
                                                                >
                                                                    <FontAwesomeIcon
                                                                        role="button"
                                                                        icon={
                                                                            faTimes
                                                                        }
                                                                    />
                                                                </button>
                                                            </div>
                                                            <hr className="mb-4" />
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <div className="form-group">
                                                                        <Multiselect
                                                                            id="seleccion-motivo"
                                                                            data={
                                                                                this.state.HasAccion === false ? motivosall :
                                                                                this.state.Accion === "HAB" ? motivoshab : motivosdes
                                                                            }
                                                                            value={
                                                                                this.state.Motivo
                                                                            }
                                                                            onChange={(
                                                                                value
                                                                            ) => {
                                                                                this.setState(
                                                                                    {
                                                                                        Motivo: value,
                                                                                    }
                                                                                );
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div
                                                    className={
                                                        "py-1 col-12 col-sm-12 col-md-6 col-lg-6 " +
                                                        (!this.state.HasUsuario
                                                            ? "d-none"
                                                            : "")
                                                    }
                                                >
                                                    <div className="card bg-ligth shadow p-3 mb-5 bg-white rounded">
                                                        <div className="card-body">
                                                            <div className="card-title mb-4">
                                                                <strong>
                                                                    Usuario
                                                                </strong>
                                                                <button
                                                                    className="btn btn-danger btn-sm float-right"
                                                                    onClick={() => {
                                                                        this.setState(
                                                                            {
                                                                                HasUsuario: false,
                                                                                somethingChanged: true,
                                                                                nextTokenHistorial:
                                                                                    "",
                                                                                nextTokenStatus:
                                                                                    "",
                                                                            }
                                                                        );
                                                                    }}
                                                                >
                                                                    <FontAwesomeIcon
                                                                        role="button"
                                                                        icon={
                                                                            faTimes
                                                                        }
                                                                    />
                                                                </button>
                                                            </div>
                                                            <hr className="mb-4" />
                                                            <div className="row">
                                                                <div className="col-md-12">
                                                                    <div className="form-group">
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            value={
                                                                                this
                                                                                    .state
                                                                                    .Usuario
                                                                            }
                                                                            onChange={(
                                                                                e
                                                                            ) => {
                                                                                this.setState(
                                                                                    {
                                                                                        Usuario:
                                                                                            e
                                                                                                .target
                                                                                                .value,
                                                                                    }
                                                                                );
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : (
                                            <>
                                                <div className="d-flex justify-content-center mt-5 mb-5">
                                                    <div className="row text-center">
                                                        <div className="col-12">
                                                            <h5>
                                                                No se ha
                                                                seleccionado
                                                                ningun filtro
                                                            </h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className="btn-group mt-3 float-right"
                            role="group"
                        >
                            {this.state.search_button_disabled ? (
                                <button className="btn btn-primary" disabled>
                                    <span
                                        className="spinner-grow spinner-grow-sm"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                    <span className="sr-only">
                                        Procesando...
                                    </span>
                                </button>
                            ) : (
                                <button
                                    type="button"
                                    className={
                                        "btn btn-primary " +
                                        (this.state.search_button_disabled
                                            ? "disabled"
                                            : "")
                                    }
                                    onClick={() => {
                                        this.setState({
                                            paginaActualHistorial: 0,
                                            paginaActualStatus: 0,
                                        });
                                        this.RunStatus();
                                        this.RunHistorial();
                                    }}
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Para exportar Excel primero realiza una busqueda"
                                >
                                    <FontAwesomeIcon
                                        role="button"
                                        icon={faSearch}
                                    />{" "}
                                    Buscar
                                </button>
                            )}

                            {this.state.dataCargada ? (
                                this.state.download_button_disabled ? (
                                    <button
                                        className="btn btn-primary"
                                        disabled
                                    >
                                        <span
                                            className="spinner-grow spinner-grow-sm"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                        <span className="sr-only">
                                            Procesando...
                                        </span>
                                    </button>
                                ) : (
                                    <button
                                        type="button"
                                        className={
                                            "btn btn-success " +
                                            (this.state.download_button_disabled
                                                ? "disabled"
                                                : "")
                                        }
                                        onClick={() => this.DescargarReporte()}
                                    >
                                        <FontAwesomeIcon
                                            role="button"
                                            icon={faFileExport}
                                        />{" "}
                                        Generar Excel
                                    </button>
                                )
                            ) : null}
                        </div>
                    </div>
                </div>
                {this.state.dataCargada ? (
                    <div className="row mt-3">
                        <div className="col-md-12">
                            <ul className="nav nav-tabs">
                                <li className="nav-item">
                                    <button
                                        className={
                                            "btn btn-link nav-link" +
                                            (this.state.viendoStatus
                                                ? " active"
                                                : "")
                                        }
                                        onClick={() => {
                                            if (!this.state.viendoStatus)
                                                this.setState({
                                                    viendoStatus: true,
                                                });
                                        }}
                                        href="#"
                                    >
                                        Status
                                    </button>
                                </li>
                                {this.state.obtuvoHistorial ? (
                                    <li className="nav-item">
                                        <button
                                            className={
                                                "btn btn-link nav-link" +
                                                (!this.state.viendoStatus
                                                    ? " active"
                                                    : "")
                                            }
                                            onClick={() => {
                                                if (this.state.viendoStatus) {
                                                    this.setState({
                                                        viendoStatus: false,
                                                    });
                                                }
                                            }}
                                            href="#"
                                        >
                                            Historial
                                        </button>
                                    </li>
                                ) : null}
                            </ul>
                        </div>
                    </div>
                ) : null}
                <div className="row mt-2">
                    <div className="col-md-12">
                        {this.state.dataCargada ? (
                            body_table
                        ) : this.state.showLoader ? (
                            <div className="d-flex justify-content-center">
                                <div className="lds-ring">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}

export default Reporte;
